<template>
  <!-- Bandeau de **contenu**, pas en-tête d'application : le logo, le nom de l'utilisateur et la
       navigation appartiennent au shell Labricot, et les dupliquer ici donnait deux en-têtes
       superposés dont un seul menait quelque part (§9.4). -->
  <header class="page-banner">
    <h1 class="page-title">Mes apprentissages</h1>
    <p class="page-intro">
      Trois familles d'activités : apprendre, valider ses acquis, relever les défis de votre établissement.
    </p>
    <!-- Le niveau est répété ici en clair parce que c'est l'information que le convive cherche en
         arrivant. Il reste détaillé dans la colonne de progression, seul endroit qui le calcule. -->
    <p v-if="learner" class="page-learner">{{ learner.displayName }} — {{ learner.levelLabel }}</p>
  </header>
</template>

<script>
/**
 * Bandeau de l'écran d'apprentissage.
 *
 * Portait auparavant un en-tête d'application complet (logo, nom, niveau, avatar). Il rendait un
 * `<h1>` « NutriQuest » sans rapport avec le contenu, au-dessus de celui du shell : deux titres de
 * niveau 1 pour une page, et une identité affichée deux fois.
 */
export default {
  name: "HeaderSection",

  props: {
    // `null` pendant le chargement : le bandeau se rend quand même, seul le nom manque.
    learner: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../scss/nutriquest";

/* Bandeau centré comme celui des autres dashboards Labricot (§9.1). */
.page-banner {
  margin-bottom: 2rem;
  text-align: center;
}

.page-title {
  color: $nq-ink;
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}

.page-intro {
  color: $nq-ink-soft;
  margin: 0;
}

.page-learner {
  color: $nq-ink-soft;
  font-weight: 600;
  margin: 0.5rem 0 0 0;
}
</style>
